import { Injectable, inject } from '@angular/core';
import { CreateOrUpdateTaskDto } from 'src/app/models/process/create-or-update-task-dto';
import { CreateOrUpdateTaskIntegrationDto } from 'src/app/models/process/create-or-update-task-integration-dto';
import { CreateOrUpdateTaskIntegrationParameterDto } from 'src/app/models/process/create-or-update-task-integration-parameter-dto';
import { TaskBaseDto } from 'src/app/models/process/task-base-dto';
import { TaskDto } from 'src/app/models/process/task-dto';
import { TaskInputType } from 'src/app/models/process/task-input-type';
import { TriggerConditionType } from 'src/app/models/process/trigger-condition-type';
import { TriggerType } from 'src/app/models/process/trigger-type';
import { CloneService } from '../clone.service';

@Injectable({
  providedIn: 'root'
})
export class TaskMapperService {
  private cloneService = inject(CloneService);

  createFrom(task: TaskDto): CreateOrUpdateTaskDto {
    const taskClone = this.cloneService.deepClone(task);
    const taskBase: TaskBaseDto = { ...taskClone };
    const result = new CreateOrUpdateTaskDto();

    const { triggerSettings } = taskBase;
    if (triggerSettings?.triggerType == TriggerType.DatePattern) {
      triggerSettings.linkedTaskPatterns = null;
      triggerSettings.conditions = null;
    } else if (triggerSettings?.triggerType == TriggerType.LinkToOtherTask) {
      triggerSettings.datePatterns = null;
      triggerSettings.enableSpecialDatePattern = false;
      triggerSettings.conditions = null;
    } else if (triggerSettings?.triggerType == TriggerType.TriggerByCondition) {
      triggerSettings.datePatterns = null;
      triggerSettings.enableSpecialDatePattern = false;
      triggerSettings.linkedTaskPatterns = null;
      if (taskBase.inputType != TaskInputType.Automatic) {
        triggerSettings.conditions.conditions =
          triggerSettings.conditions.conditions?.filter(
            c =>
              c.type != TriggerConditionType.AmountOfWork &&
              c.type != TriggerConditionType.Field
          );
      }
    }

    result.validationRuleId = taskClone.validationRule?.id;
    result.informationFieldIds = taskClone.fields
      ?.filter(f => !f.isInherited)
      ?.map(f => f.id);
    result.priorTaskIds = taskClone.priorTasks?.map(t => t.id);
    result.nextTaskIds = taskClone.nextTasks?.map(t => t.id);
    result.integrations = taskClone.integrations?.map(i => {
      const integration = new CreateOrUpdateTaskIntegrationDto();
      integration.id = i.id;
      integration.integrationId = i.integrationId;
      integration.enableFrom = i.enableFrom;
      integration.default = i.default;
      integration.parameters = i.parameters?.map(p => {
        const parameter = new CreateOrUpdateTaskIntegrationParameterDto();
        parameter.id = p.id;
        parameter.integrationParameterId = p.integrationParameterId;
        parameter.value = p.value;
        parameter.valueId = p.valueId;
        return parameter;
      });
      return integration;
    });

    return { ...result, ...taskBase };
  }
}
